<template>
    <div class="brand-page">
        <div class="row no-gutters brands-hero2" id="safetyworks2">
            <div>
                <img src="/images/brand-bgs/brand-logo-bg.png" alt="background">
                <img src="/images/brand-logos/sw-logo-trimmed.png" alt="safety works logo">
            </div>
        </div>

        <div class="brand-content">
            <div>
                <p>
                    With a strong emphasis on quality and reliability, Safety Works Professional® has earned the right to become a trusted name in the safety industry.  
                    Since being founded in 1988, we have become a reputable brand due to our commitment to providing high quality and affordable safety equipment for any project at hand. 
                    With Safety Works Professional®, you get an extensive range of safety equipment: protective clothing, head protection, safety eyewear, task-oriented gloves, and footwear. 
                    Safety Works Professional® carries the most innovative, value driven and comprehensive safety solutions in the market.  Simply put - Safety is all we do!   
                </p>
                <a href="https://safetyworks.com/" class="btn-round-black" target="_blank">Safetyworks.com</a>
            </div>
        </div>

        <div class="socialspace" style="background-color: rgb(25, 113, 83);">
            <div>
                <div>
                    <h4>Follow Us</h4>
                    <div>
                        <a href="https://www.facebook.com/SafetyWorks" target="_blank">
                            <font-awesome-icon class="social-icon" :icon="['fab', 'square-facebook']"  />
                        </a>
                        <a href="https://www.instagram.com/safetyworksbypip/" target="_blank">
                            <font-awesome-icon class="social-icon" :icon="['fab', 'square-instagram']" />
                        </a>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <h4>Contact Us</h4>
                    <div class="contact-container">            
                        <div>
                            <a href="mailto:sales@westchestergear.com">
                                <font-awesome-icon :icon="['fass', 'envelope']" />
                            </a>                 
                            <a href="mailto:sales@westchestergear.com">sales@westchestergear.com</a>
                        </div>
                        <div>
                            <a href="tel:800-969-7562">
                                <font-awesome-icon :icon="['fass', 'phone']" />
                            </a>
                            <a href="tel:800-969-7562">(800) 969-7562</a>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <h4>Buy Now</h4>
                    <div>
                        <a href="https://www.amazon.com/stores/page/780E17B6-0AF6-4F1A-9F00-07D537F3A30B?ingress=3" target="_blank" aria-label='Link opens in new window (amazon.com/stores/SafetyWorks)'>
                            <img id="amazon-logo" src="/images/amazon-logo-white.svg" alt="amazon logo">
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {};
    },
    methods: {
    }
};
</script>
